module.exports = __webpack_public_path__ + "static/img/3.41bf324.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/content-management/3.jpeg
// module id = Nlgp
// module chunks = 3